module.exports = __webpack_public_path__ + "static/mohammed-abid-lg-4acc5ca3705f7051104a3b1ce8f62773.png";